import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlockSortAscending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"block-sort-ascending"} maskId="square-filled-radius-0-stroke-1-IconBlockSortAscending"><path d="M11 21H3V13H11V21Z" fill="currentColor"/><path d="M22.3535 10.6465L21.6465 11.3535L18 7.70703V18H17V7.70703L13.3535 11.3535L12.6465 10.6465L17.5 5.79297L22.3535 10.6465Z" fill="currentColor"/><path d="M11 11H3V3H11V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBlockSortAscending;
